import { useMemo } from "react";

import { useQueryMetadata } from "@components/v2/modals";
import { SALES_METRICS_REPORT_V4 } from "@gql/sales-page-v4";
import { useNorthbeamQuery } from "@hooks/http";
import {
  type GetSalesMetricsReportV4,
  type GetSalesMetricsReportV4Variables,
} from "@north-beam/nb-client-side";
import { type SalesMetricRow } from "@north-beam/nb-common";

export const useSalesMetricsReportQuery = ({
  queryName,
  variables,
  skip = false,
}: {
  queryName: string;
  variables: GetSalesMetricsReportV4Variables;
  skip?: boolean;
}) => {
  const { addQueryMetadata } = useQueryMetadata();

  const { data, loading } = useNorthbeamQuery<
    GetSalesMetricsReportV4,
    GetSalesMetricsReportV4Variables
  >(SALES_METRICS_REPORT_V4, {
    skip,
    variables,
    onCompleted(data) {
      addQueryMetadata({
        context: "Revenue",
        topic: queryName,
        metadata: data.me.salesMetricsReportV4.queryMetadata,
      });
    },
  });

  const rows = useMemo(() => {
    return {
      actualRows: (data?.me.salesMetricsReportV4.actual ||
        []) as SalesMetricRow[],
      comparisonRows: (data?.me.salesMetricsReportV4.comparison ||
        []) as SalesMetricRow[],
    };
  }, [data]);

  return { rows, loading };
};
